const getBuildUP = (chg, oiChg) => {
    let bu = "";

    if (chg > 0 && oiChg > 0) {
        bu = 'LB';
    } else if (chg < 0 && oiChg > 0) {
        bu = 'SB';
    } else if (chg > 0 && oiChg < 0) {
        bu = 'SC';
    } else if (chg < 0 && oiChg < 0) {
        bu = 'LU';
    }
    return bu;
}

export const getFullFutStocks = (data, prevData) => {
    let SymData = getFutStock(data,  prevData);

    return {
        ...SymData,
        pcr : SymData.oiCE !== 0 ? (SymData.oiPE / SymData.oiCE) : undefined,
    }
};

export const getFullStrikeStocks = (ceSym, peSym, strike, prevData) => {
    let ceSymData = getStock(ceSym, 'CE', prevData);
    let peSymData = getStock(peSym, 'PE', prevData);

    return {
        ...ceSymData,
        ...peSymData,
        pcrCE : ceSymData.oiCE !== 0 ? (peSymData.oiPE / ceSymData.oiCE) : undefined,
        pcrPE : ceSymData.oiCE !== 0 ? (peSymData.oiPE / ceSymData.oiCE) : undefined,
        strike: strike
    }
};

export const getStock = (sym, type , prevData) => {
    let prevLP = prevData[type].lp || 0;
    let prevOI = prevData[type].oi || 0;
    let prevIV = prevData[type].iv || 0;
    
    let buildUP = getBuildUP(sym?.lp - prevLP, sym?.oi - prevOI)
    if(type=="CE") {
        var trend = (buildUP === "LB" || buildUP === "SC") ? "Bullish" : (buildUP === "SB" || buildUP === "LU") ? "Bearish" : "";
     } else {
         var trend = (buildUP === "SB" || buildUP === "LU") ? "Bullish" : (buildUP === "SC" || buildUP === "LB") ? "Bearish" : "";
     }
 
    return {
        ["ivChg" +type] : prevIV !== 0 ? ((100 * (sym?.iv - prevIV)) / prevIV) : null,
        ["iv" +type] : sym?.iv,
        ["lp" +type] : sym?.lp,
        ["chg" +type] : sym?.lp - prevLP,
        ["pChg" +type] : prevLP !== 0 ? ((100 * (sym?.lp - prevLP)) / prevLP) : null,
        ["oi" +type] : sym?.oi,
        ["oiChg" +type] : sym?.oi - prevOI,
        ["oiPChg" +type] :prevOI !== 0 ? (100 * (sym?.oi - prevOI)) / prevOI: null,
        ["vol" +type] : sym?.vt,
        ["buildup" +type] :buildUP ,
        ["trend" +type] : trend ,
        ["orderflow" +type] :sym?.cdv ,
        ["delta" +type] :sym?.d ,
        ["gamma" +type] :sym?.g ,
        ["theta" +type] :sym?.t ,
        ["vega" +type] :sym?.ve ,
        ["bid" +type] :sym?.bid.p ,
        ["ask" +type] :sym?.ask.p ,
        ["atp" +type] :sym?.atp ,
        ["ltpChgOpen" +type] :sym?.lp - sym?.do,
        ["ltpChgPOpen" +type] :sym?.do !== 0 ? ((100 * (sym?.lp - sym?.do)) / sym?.do) : null,
    }
};


export const getFutStock = (sym,  prevData) => {
    let prevLP = prevData.lp || 0;
    let prevOI = prevData.oi || 0;
    let prevIV = prevData.iv || 0;
    
   
 
    return {
        ["ivChg"] : prevIV !== 0 ? ((100 * (sym?.iv - prevIV)) / prevIV) : null,
        ["iv" ] : sym?.iv,
        ["lp" ] : sym?.lp,
        ["chg" ] : sym?.lp - prevLP,
        ["pChg" ] : prevLP !== 0 ? ((100 * (sym?.lp - prevLP)) / prevLP) : null,
        ["oi" ] : sym?.oi,
        ["oiChg" ] : sym?.oi - prevOI,
        ["oiPChg" ] :prevOI !== 0 ? (100 * (sym?.oi - prevOI)) / prevOI: null,
        ["vol" ] : sym?.vt,
        ["orderflow" ] :sym?.cdv ,
        ["delta" ] :sym?.d ,
        ["gamma" ] :sym?.g ,
        ["theta" ] :sym?.t ,
        ["vega" ] :sym?.ve ,
        ["bid" ] :sym?.bid.p ,
        ["ask" ] :sym?.ask.p ,
        ["atp" ] :sym?.atp ,
        ["ltpChgOpen" ] :sym?.lp - sym?.do,
        ["ltpChgPOpen" ] :sym?.do !== 0 ? ((100 * (sym?.lp - sym?.do)) / sym?.do) : null,
    }
};
